<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  import RelatorioLoading from './_RelatorioLoading'

  export default {
    components: {RelatorioLoading},
    nome: 'relatorio-leilao-saida-arrematante',
    directives: {mask},
    data () {
      let situacaoLote = [
        {label: 'Vendidos', value: 6, class: 'btn-default'}, /*,  class: 'btn-info' */
        {label: 'Condicionais', value: 7, class: 'btn-default'}, /*,  class: 'btn-primary' */
        {label: 'Sem licitantes', value: 8, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Baixa Oferta', value: 9, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Retirados', value: 10, class: 'btn-default'} /* , class: 'btn-success' */
      ]
      return {
        isLoading: false,
        leilao: null,
        vendas: null,
        tiposLeilao: [
          {label: 'Qualquer', value: '', class: 'btn-default'},
          {label: 'Online', value: 2, class: 'btn-default'},
          {label: 'Presencial', value: 1, class: 'btn-default'}
        ],
        situacaoLote: situacaoLote,
        filterKey: '',
        sortKey: '',
        filtro: {
          tipo: '',
          situacao: situacaoLote.map(a => a.value)
        },
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        showFiltros: false
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let filtrosFixos = this.filtro
        let order = this.sortOrders[sortKey] || 1
        let data = this.leilao.lotes
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }

        // Situação
        data = data.filter(function (row) {
          return filtrosFixos.situacao.some(el => el === row.status)
        })

        // Tipo
        console.log(filtrosFixos.tipo)
        if (filtrosFixos.tipo) {
          data = data.filter(function (row) {
            if (!row.arremate) {
              return false // Não foi arrematado
            }
            let test
            if (filtrosFixos.tipo === 2) { // Online
              test = row.arremate.arrematante.apelido !== 'PLATEIA'
            } else if (filtrosFixos.tipo === 1) { // Presencial
              test = row.arremate.arrematante.apelido === 'PLATEIA'
            } else {
              test = true
            }
            return test
          })
        }

        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      getStatus () {
        return Status.Status
      },
      Status () {
        return Status
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.isLoading = true
      service.relatorioSaidaArrematante(this.$route.params.id)
        .then((response) => {
          this.isLoading = false
          this.leilao = response.data.leilao
          this.vendas = response.data.vendas
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    deactivated () {
    },
    watch: {},
    methods: {
      bindMargemClass (arremate, minimo) {
        let sum = Number(arremate) - Number(minimo)
        return {
          'text-danger': sum < 0,
          'text-success': sum >= 0
        }
      }
    }
  }
</script>

<template>
  <div class="r-container" :class="{'is-loading': isLoading}">
    <relatorio-loading v-if="isLoading"></relatorio-loading>
    <transition name="slide">
      <div v-if="!isLoading" class="content-transition relatorio-print" id="container-printer">
        <div class="hidden-print">
          <!--<div class="text-center m-t m-b-n">
            <h3 @click="showFiltros = !showFiltros" class="btn m-t-none"><span class="btn btn-default btn-xs m-r-xs">{{ !showFiltros ? '+' : '-' }}</span>Filtros</h3>
          </div>-->
          <div class="r-table" v-show="showFiltros">
            <div class="r-table-content">
              <div class="m-t">
                <div class="m-b">
                  <div>Tipo de Venda:</div>
                  <u-button-group v-model="filtro.tipo" :options="tiposLeilao"></u-button-group>
                </div>
                <div class="m-b">
                  <div>Situação:</div>
                  <u-button-group :multiSelect="true" v-model="filtro.situacao"
                                  :options="situacaoLote"></u-button-group>
                </div>
                <div class="m-b">
                  Resultados: {{ vendas && vendas.length }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hidden-print">
          <h2 class="text-center text-uppercase font-bold m-b-none">Relatório de Venda por Arrematante</h2>
          <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
            }}</h4>
        </div>
        <div v-for="(venda, key) in vendas" class="printer-page pos-rlt">
          <div class="visible-print">
            <h2 class="text-center text-uppercase font-bold m-b-none">Relatório de Saída de Bens</h2>
            <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
              }}</h4>
          </div>
          <div class="r-table">
            <div class="r-table-header">
              <div class="pull-left font-bold text-black">{{ venda.arrematante.apelido }} - {{ venda.arrematante.pessoa.nome }}</div>
              <!--<div class="pull-right font-bold">{{venda.vendas.length}} lote{{venda.vendas.length > 1 ? 's' : ''}}</div>-->
              <div class="clearfix"></div>
            </div>
            <div class="r-table-content">

              <div class="m-t">
                <table class="w-full table table-bordered m-b-none">
                  <tbody>
                  <tr>
                    <td>Arrematante</td>
                    <td colspan="3" class="font-bold">{{ venda.arrematante.pessoa.nome }}
                      ({{ venda.arrematante.apelido }}) #A{{ venda.arrematante.id }}-P{{
                      venda.arrematante.pessoa.id }}

                      <!--<table class="w-full">
                        <tr>
                          <td>CPF</td>
                          <td>{{ venda.arrematante.pessoa.pfCpf }}</td>
                        </tr>
                      </table>-->


                    </td>
                  </tr>
                  <tr v-if="venda.arrematante.pessoa.tipo === 1">
                    <td>Tratamento</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfTratamento }}</td>
                    <td>Sexo</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfSexo === 1 ? 'M' : 'F' }}</td>
                  </tr>
                  <tr v-if="venda.arrematante.pessoa.tipo === 1">
                    <td>CPF</td>
                    <td class="font-bold"><span v-if="venda.arrematante.pessoa.pfCpf">{{ venda.arrematante.pessoa.pfCpf | formataCpf }}</span><span v-else>SEM CPF</span></td>
                    <td>RG</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfRg }} {{
                      venda.arrematante.pessoa.pfRgOrgaoEmissor }}
                    </td>
                  </tr>
                  <tr v-if="venda.arrematante.pessoa.tipo === 1">
                    <td>Data de Nascimento</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfDataNascimento ?
                      moment(venda.arrematante.pessoa.pfDataNascimento.date).format('L') : '-' }}
                    </td>
                    <td>Estado Civil</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfEstadoCivilString }}</td>
                  </tr>
                  <tr
                    v-if="venda.arrematante.pessoa.tipo === 1 && (venda.arrematante.pessoa.pfFiliacaoNomePai || venda.arrematante.pessoa.pfFiliacaoNomeMae)">
                    <td>Nome do Pai</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfFiliacaoNomePai }}</td>
                    <td>Nome da Mãe</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pfFiliacaoNomeMae }}</td>
                  </tr>
                  <tr v-if="venda.arrematante.pessoa.tipo === 2">
                    <td>Razão Social</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pjRazaoSocial ||
                      venda.arrematante.pessoa.nome }}
                    </td>
                    <td>Nome Fantasia</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pjNomeFantasia }}</td>
                  </tr>
                  <tr v-if="venda.arrematante.pessoa.tipo === 2">
                    <td>CNPJ</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pjCnpj }}</td>
                    <td>Inscrição Estadual</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.pjInscricaoEstadual }}</td>
                  </tr>
                  <tr v-if="venda.arrematante.pessoa.tipo === 2">
                    <td>Responsável</td>
                    <td class="font-bold">{{ venda.arrematante.pjProprietarioNome }}</td>
                    <td>CPF</td>
                    <td class="font-bold"><span v-if="venda.arrematante.pjProprietarioCpf">{{ venda.arrematante.pjProprietarioCpf | formataCpf }}</span><span v-else>SEM CPF DO RESPONSÁVEL</span></td>
                  </tr>
                  <tr>
                    <td>IP Cadastro</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.ipCadastro }}</td>
                    <td>Observação</td>
                    <td class="font-bold">{{ venda.arrematante.pessoa.observacao }}</td>
                  </tr>
                  </tbody>
                </table>

                <!-- ENDEREÇOS -->
                <div class="tab-border no-border-top">
                  <table class="w-full table-arremate">
                    <thead>
                    <tr>
                      <th>
                        Endereço
                      </th>
                      <th style="width: 18%; white-space: nowrap">
                        Cidade
                      </th>
                      <th style="width: 18%; white-space: nowrap">
                        UF
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="endereco in venda.arrematante.pessoa.enderecos">
                      <td>
                        {{ endereco.logradouro }}, {{ endereco.numero }} {{ endereco.complemento }}, {{ endereco.bairro
                        }}, {{ endereco.cep | formataCep }}
                      </td>
                      <td>
                        {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}
                      </td>
                      <td>
                        {{ endereco.municipio && endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- CONTATOS -->
                <div class="tab-border no-border-top">
                  <table class="w-full table-arremate">
                    <thead>
                    <tr>
                      <th>
                        Email
                      </th>
                      <th style="width: 18%; white-space: nowrap">
                        Finalidade
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="email in venda.arrematante.pessoa.emails">
                      <td>
                        {{ email.email }}
                      </td>
                      <td>
                        {{ email.finalidade ? email.finalidade.nome : '-' }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- TELEFONES -->
                <div class="tab-border no-border-top">
                  <table class="w-full table-arremate">
                    <thead>
                    <tr>
                      <th>
                        Telefone
                      </th>
                      <th style="width: 18%; white-space: nowrap">
                        Finalidade
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="telefone in venda.arrematante.pessoa.telefones">
                      <td>
                        {{ telefone.telefone | formataTelefone }}
                      </td>
                      <td>
                        {{ telefone.finalidade ? telefone.finalidade.nome : '-' }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!--<table class="w-full table table-bordered m-b-none">
                  <thead>
                  <tr>
                    <th>
                      Arrematante
                    </th>
                    <th style="width: 10%; white-space: nowrap">
                      CPF
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{{ venda.arrematante.pessoa.nome }}
                      ({{ venda.arrematante.apelido }})

                      &lt;!&ndash;<table class="w-full">
                        <tr>
                          <td>CPF</td>
                          <td>{{ venda.arrematante.pessoa.pfCpf }}</td>
                        </tr>
                      </table>&ndash;&gt;


                    </td>
                    <td>{{ venda.arrematante.pessoa.pfCpf }}</td>
                  </tr>
                  </tbody>
                </table>
                <table class="w-full table table-bordered m-t-none no-borders">
                  <thead>
                  <tr>
                    <th>
                      RG
                    </th>
                    <th style="width: 10%; white-space: nowrap">
                      ÓRGÃO EMISSOR
                    </th>
                    <th style="width: 20%; white-space: nowrap">
                      EMAIL
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{{ venda.arrematante.pessoa.nome }}
                      ({{ venda.arrematante.apelido }})

                      &lt;!&ndash;<table class="w-full">
                        <tr>
                          <td>CPF</td>
                          <td>{{ venda.arrematante.pessoa.pfCpf }}</td>
                        </tr>
                      </table>&ndash;&gt;


                    </td>
                    <td>{{ venda.arrematante.pessoa.pfCpf }}</td>
                    <td>{{ venda.arrematante.pessoa.pfCpf }}</td>
                  </tr>
                  </tbody>
                </table>-->
              </div>

              <div class="tab-border m-t-lg">
                <table class="w-full table-arremate">
                  <thead>
                  <tr>
                    <th style="width: 40px; max-width: 40px; white-space: nowrap">
                      Lote
                    </th>
                    <th style="width: 30%; white-space: nowrap">
                      Descrição
                    </th>
                    <th style="width: 18%; white-space: nowrap">
                      Valor Arremate
                    </th>
                    <th style="width: 18%; white-space: nowrap">
                      Mínimo
                    </th>
                    <th style="width: 18%; white-space: nowrap">
                      Com&Taxas
                    </th>
                    <th style="width: 18%; white-space: nowrap">
                      Total
                    </th>
                    <th style="width: 18%; white-space: nowrap">
                      Situação
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="lote in venda.vendas" :key="lote.id" class="list" style="font-size: 12px">
                    <td style="font-size: 15px">
                      {{lote.numero}}
                    </td>
                    <td style="font-size: 10px; line-height: 1">
                      {{lote.titulo}}
                    </td>
                    <td style="white-space: nowrap">
                      R${{ lote.valorArremate | moeda }}
                    </td>
                    <td style="white-space: nowrap">
                      R${{ lote.valorMinimo | moeda }}
                    </td>
                    <td>R${{ (Number(lote.comissaoValor) +  Number(lote.taxa)) | moeda }}</td>
                    <td>R${{ lote.total | moeda }}</td>
                    <td><strong :class="'text-' + Status.Status[lote.status].class">{{
                      Status.Status[lote.status].titulo }}</strong></td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
          <div class="p-page-numer visible-print">Página {{key+1}} de {{vendas && vendas.length}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>



// WEBPACK FOOTER //
// RelatorioSaidaArrematante.vue?4cec9d0f